import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'overview-item-one',
  templateUrl: './item-one.component.html',
  styles: ['.item-one { padding: 10px; background-color: lightblue; }']
})
export class ItemOneComponent implements OnInit {
	@Input() job: any;
	constructor() {
		
	}
	ngOnInit() {
		console.log(this.job);
	}
}